import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectClientSite } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import { Banner } from "@metacrm/metacrm-material-ui/dist/Banner";

export default function DemoBanner() {
  const isClientSite = useSelector(selectClientSite);
  const [remindOpen, setRemindOpen] = useState(isClientSite);

  const handleCloseRemindModal = () => {
    setRemindOpen(false);
  };

  return (
    <Banner
      show={remindOpen}
      message="This is a demo site for showcase purposes. All data is fictitious."
      onClickCloseIcon={handleCloseRemindModal}
    />
  );
}
